/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
import InfinityLoader from '@/components/common/infinityLoader'
import boxSx from '@/components/common/sx/boxSx'
import useUserBankAccount from '@/hooks/Dashoboard/Members/Profile/useUserBankAccount'
import { BankAccount } from '@/types/graphql/types'
import {
  Button,
  Container,
  Group,
  LoadingOverlay,
  Select,
  Sx,
  TextInput,
  Title,
} from '@mantine/core'
import banksName from 'const/banks'
import useTranslation from 'next-translate/useTranslation'

const UserBankAccount = ({
  bankAccount,
  sx,
  refetch,
}: {
  bankAccount: BankAccount
  sx?: Sx
  refetch?: () => void
}) => {
  const { t } = useTranslation('common')
  const { submit, loading, form } = useUserBankAccount({
    bankAccount,
    sx,
    refetch,
  })

  return (
    <Container sx={sx || boxSx} className="relative">
      <form onSubmit={form.onSubmit(submit)} className="relative">
        <Title order={3}>{t('bankAccount')}</Title>

        <LoadingOverlay
          loader={<InfinityLoader variant="lg" />}
          visible={loading}
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <TextInput
            required
            label={t('accountHolderName')}
            {...form.getInputProps('accountHolderName')}
            className="col-span-2"
          />
          <Select
            data={banksName}
            label={t('bankName')}
            {...form.getInputProps('bankName')}
            required
          />
          <TextInput
            label={t('iban')}
            {...form.getInputProps('iban')}
            required
          />
        </div>
        <Group position="center" pt={10}>
          <Button type="submit">{t('save')}</Button>
        </Group>
      </form>
    </Container>
  )
}

export default UserBankAccount
